import './Jumbotron.css';

function Jumbotron() {
    return (
        <div className='jumbotron'>
            <h1>
                Descrow
            </h1>
            <h2>
                A decentralized escrow protocol facilitating trustless payments
            </h2>
        </div>
    )
}

export default Jumbotron;